export default __webpack_public_path__ + "static/media/EMI.814c8a5d.svg";